module.exports = __webpack_public_path__ + "static/media/039.e6a71a8e.png";